import React from "react";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import CardBody from "../../../components/Card/CardBody";
import { Card, Collapse, GridLegacy, Alert } from "@mui/material";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import { waitTimeMode } from "../../../variables/app";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormTimePicker from "../../../components/Forms/FormTimePicker";
import FormTextTC from "../../../components/Forms/FormTextTC";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import { OpeningHoursSettings } from "../../../../../Components/OpeningHours/OpeningHoursSettings.tsx";
import {
  PreOrderExtension,
  PreOrderExtensionValues,
} from "../../../../../Components/OpeningHours/PreOrderExtension.tsx";

function Preordering() {
  const waitTimeModeOptions = convertArrayToSelectOptions(waitTimeMode);

  const { control, vestigingId } = useFormContext();

  const {
    field: { value: openingHours, onChange: openingHoursChange },
  } = useController({ control, name: "time_settings__opening_hours" });

  const {
    field: { value: preOrderOpeningHours, onChange: preOrderOpeningHoursChange },
  } = useController({ control, name: "time_settings__preordering_hours" });

  const preOrderingActive = useWatch({ name: "preOrderingActive" });
  const preOrdering = useWatch({ name: "preOrdering" });

  return (
    <GridLegacy container spacing={1}>
      <GridLegacy alignContent={"flex-start"} item lg={6} xs={12}>
        <GridLegacy container spacing={1}>
          <GridLegacy alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16 }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Openingstijden"}
                      tKey={"vestigingen.form.tijden.headers.openingstijden"}
                    />
                  </h3>
                  <h4>
                    <TranslationWrapper
                      tDefault={"The times when the application is usable for guests"}
                      tKey={"vestigingen.form.tijden.headers.timesThatTheGuestCanUseTheApplication"}
                    />
                  </h4>
                </GridLegacy>

                <Accordion defaultExpanded={true} sx={{ width: "100%" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <TranslationWrapper
                      tDefault={"Timetable"}
                      tKey={"vestigingen.form.delivery_settings.label.timeTableValue"}
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    <OpeningHoursSettings
                      openingHours={openingHours}
                      onChange={(openingHours) => openingHoursChange(openingHours)}
                    />
                  </AccordionDetails>
                </Accordion>
              </CardBody>
            </Card>
          </GridLegacy>
          <GridLegacy alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Pre ordering Events"}
                      tKey={"vestigingen.form.tijden.headers.preordering_events"}
                    />
                  </h3>
                </GridLegacy>
                <FormSwitchTC
                  name={"preOrdering"}
                  tDefault={"Pre ordering op voorstellingen"}
                  tKey={"vestigingen.form.preordering.label.preOrdering"}
                />
                {preOrdering ? (
                  <FormControlledInputTC
                    name={"preOrderHideAfter"}
                    rules={{
                      min: { value: 0, message: getTranslation("The minimum value is 0!") },
                    }}
                    suffix={" " + getTranslation("global.minuten", "Minuten")}
                    tDefault={"Hide slot x minutes before"}
                    tKey={"vestigingen.form.preordering.label.preOrderHideAfter"}
                    type={"number"}
                  />
                ) : null}
              </CardBody>
            </Card>
          </GridLegacy>
        </GridLegacy>
      </GridLegacy>
      <GridLegacy alignContent={"flex-start"} item lg={6} xs={12}>
        <GridLegacy container spacing={1}>
          <GridLegacy alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"Verlooptijd"} tKey={"vestigingen.form.tijden.headers.verlooptijd"} />
                  </h3>
                </GridLegacy>
                <FormTextTC
                  name={"logoutUrl"}
                  tDefault={"Na verlooptijd naar url"}
                  tKey={"vestigingen.form.overige.label.logoutUrl"}
                />
                <FormTextTC
                  name={"logoutRedirect"}
                  tDefault={"Logout redirect"}
                  tKey={"vestigingen.form.overige.label.logoutRedirect"}
                />
              </CardBody>
            </Card>
          </GridLegacy>
          <GridLegacy alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Pre ordering (datum/tijd)"}
                      tKey={"vestigingen" + "." + "form.tijden.headers.preordering"}
                    />
                  </h3>
                </GridLegacy>
                <FormSwitchTC
                  name={"preOrderingActive"}
                  tDefault={"Pre ordering actief op datum & tijd"}
                  tKey={"vestigingen.form.preordering.label.preOrderingActive"}
                />
                {preOrderingActive ? (
                  <>
                    <OpeningHoursSettings<PreOrderExtensionValues>
                      openingHours={preOrderOpeningHours}
                      onChange={(openingHours) => preOrderOpeningHoursChange(openingHours)}
                      ExtensionComponent={PreOrderExtension}
                      emptyExtensionData={{ maxOrders: 5, maxOrderValue: 0 }}
                    />
                    <FormControlledInputTC
                      name={"preOrderTimeOffset"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tDefault={"Time block size"}
                      tKey={"vestigingen.form.preordering.label.preOrderTimeOffset"}
                      type={"number"}
                    />

                    <FormSelectTC
                      name={"waitTimeMode"}
                      options={waitTimeModeOptions}
                      tDefault={"Wachtijd modus"}
                      tKey={"vestigingen.form.overige.label.waitTimeMode"}
                    />

                    <FormControlledInputTC
                      name={"waitTime"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tKey={"Wachtijd bestelling"}
                      type={"number"}
                    />
                    <FormTimePicker
                      name={"preOrderSameDayDeliveryBefore"}
                      tDefault={"Besteld voor X uur (SDD)"}
                      tKey={"vestigingen.form.preordering.label.preOrderSameDayDeliveryBefore"}
                    />
                    <FormControlledInputTC
                      name={"delivery_settings__deliverydayOffset"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.dagen", "dag(en)")}
                      tDefault={"Eerst volgende dag bezorging"}
                      tKey={"vestigingen.form.preordering.label.deliverydayOffset"}
                      type={"number"}
                    />
                    <FormControlledInputTC
                      name={"preOrderMaxDays"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.dagen", "dag(en)")}
                      tDefault={"Max dagen vooruit"}
                      tKey={"vestigingen.form.preordering.label.preOrderMaxDays"}
                      type={"number"}
                    />
                    <FormControlledInputTC
                      name={"preOrderPrintOffsetMin"}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tDefault={"Print x minuten van te voren"}
                      tKey={"vestigingen.form.preordering.label.preOrderPrintOffsetMin"}
                      type={"number"}
                    />
                  </>
                ) : null}
              </CardBody>
            </Card>
          </GridLegacy>
        </GridLegacy>
      </GridLegacy>
    </GridLegacy>
  );
}

export default Preordering;
